import { emitter } from "@/eventBus/eventBus";
import store from "@/store";

export const globalErrorHandler = (error) => {
  let errorMessage = null;
  console.log(error);
  if (error.code === 401) {
    store.commit("users/SET_USER_PROFILE", undefined);
    location.href = "/login";
  }
  errorMessage = error.data.type ? error.data.type : error.type;

  emitter.emit("showErrorModal", errorMessage);
};
